
import TopBar from "./components/TopBar/TopBar";
import Sidebar from "./components/sidebar/Sidebar";
import Home from "./Pages/homepage/Homepage";
import Login from "./Pages/Login/Login";
import Settings from "./Pages/settings/Settings";
import Single from "./Pages/single/Single";
import Write from "./Pages/write/Write";
import Ads from "./Pages/ads/Ads";
import AdsForm from "./Pages/ads/AdsForm";
import Blogs from "./Pages/blogs/Blogs";
import BlogForm from "./Pages/blogs/BlogForm";
import Bookings from "./Pages/bookings/Bookings";
import HotSections from "./Pages/hotSections/HotSections";
import HotSectionForm from "./Pages/hotSections/HotSectionForm";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { Context } from "./Context/Context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

function App() {
  const { user } = useContext(Context);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  // Close mobile sidebar on route change / resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) setIsMobileOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  if (!user) {
    return (
      <Router>
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="*">
            <Login />
          </Route>
        </Switch>
      </Router>
    );
  }

  return (
    <Router>
      <div className="app">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
        {/* Mobile overlay backdrop */}
        {isMobileOpen && (
          <div 
            className="sidebar-overlay" 
            onClick={() => setIsMobileOpen(false)} 
          />
        )}
        <Sidebar 
          isCollapsed={isSidebarCollapsed} 
          onToggle={setIsSidebarCollapsed}
          isMobileOpen={isMobileOpen}
          onMobileClose={() => setIsMobileOpen(false)}
        />
        <div className={`app-content ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          <TopBar onMobileMenuToggle={() => setIsMobileOpen(prev => !prev)} isMobileMenuOpen={isMobileOpen} />
          <div className="main-content">
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route path="/write">
                <Write />
              </Route>
              <Route path="/settings">
                <Settings />
              </Route>
              <Route path="/post/:postId">
                <Single />
              </Route>
              <Route exact path="/bookings">
                <Bookings />
              </Route>
              <Route exact path="/blogs">
                <Blogs />
              </Route>
              <Route path="/blogs/create">
                <BlogForm />
              </Route>
              <Route path="/blogs/edit/:id">
                <BlogForm />
              </Route>
              <Route exact path="/ads">
                <Ads />
              </Route>
              <Route path="/ads/create">
                <AdsForm />
              </Route>
              <Route path="/ads/edit/:id">
                <AdsForm />
              </Route>
              <Route exact path="/hot-sections">
                <HotSections />
              </Route>
              <Route path="/hot-sections/create">
                <HotSectionForm />
              </Route>
              <Route path="/hot-sections/edit/:id">
                <HotSectionForm />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
